import React from 'react';

import { spacing } from '~/src/dash/components/layout/common';

interface IPanelBreakProps {
  // must be in string px or percent format; ex. 16px
  // prioritize using the spacing object; ex. spacing.small
  height?: string;
}

// this component solves the lack of space at the bottom of the page
// due to a nested scroll
export const PanelBreak = ({ height }: IPanelBreakProps) => {
  return (
    <div
      style={{
        position: 'relative',
        minHeight: height || spacing.base,
      }}
    ></div>
  );
};
